<template>
  <header>
    <router-link :to="{ name: 'Homepage', params: { lang: $route.params.lang}}">
      <div class="header-title">{{$t('nav.title')}}</div>
    </router-link>
    <div class="header-primary">
      <MenuButton/>

      <div class="header-logo">
        <a href="https://www.schneider-electric.com/ww/en/" target="_blank"><SeLogo/></a>
      </div>

      <ShareButton/>
    </div>

    <ShareDrawer />
  </header>
</template>

<script>
import MenuButton from './MenuButton'
import ShareButton from './ShareButton'
import ShareDrawer from './ShareDrawer'

import SeLogo from '../assets/se-logo.svg'

export default {
  name: 'PageHeader',
  components: {
    MenuButton,
    ShareButton,
    ShareDrawer,
    SeLogo
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/vars';
header {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  flex-direction: column;
  z-index: 100;
  .menu-button {
    @media(min-width: $screen-sm-min) {
      display: none; // Hide this menu button on larger screens
    }
  }
  #ShareButton {
    @media(min-width: $screen-sm-min) {
      display: none;
    }
  }
}
.header-primary {
  padding: 7px 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: .4s background-color;
  @media(min-width: $screen-sm-min) {
    justify-content: flex-end;
    padding: 0;
    border-bottom: none;
  }
  svg {
    fill: $white;
    transition: .4s fill;
  }
  .header-logo {
    @media(min-width: $screen-sm-min) {
      padding: 12px 20px;
      width: 178px;
    }
    width: 138px;
    border-bottom-left-radius: 10px;
    transition: .4s background-color;
    svg {
      width: 138px;
      height: 28px;
    }
  }
}
.header-title {
  color: $white;
  line-height: 37px;
  height: 37px;
  text-align: center;
  background: $green-light;
  @media(min-width: $screen-sm-min) {
    display: none;
  }
}
#app.belowhero, #app.menu-opened {
  .header-primary {
    background: $white;
    border-bottom: 1px solid #EFEFEF;
    @media(min-width: $screen-sm-min) {
      border-bottom: none;
      background: inherit;
    }
  }
  header .header-logo {
    background: $white;
    svg {
      fill: $green-light;
    }
  }
}
// Now undo all of this for small+ screens (because mobile first)
@media(min-width: $screen-sm-min) {
  #app.menu-opened:not(.belowhero) {
    header .header-logo {
      background: inherit;
      svg { fill: $white; } // No we're still white when the menu is opened
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue